import { styled } from '@styledComponents';
import { Text } from '@components/typography';
import { PlaceholderCloudImage } from '@components/CloudImage';
import { themeSpace } from '@utils/styledTheme.util';
import { Flex } from '@components/Flex';
import { ButtonNoneStyled } from '@components/ButtonNoneStyled';

export const StyledWrapper = styled(Flex)<{ left?: string }>`
  position: absolute;
  top: 0;
  left: ${(props) => props.left + 'px' || '0px'};
`;

export const SelectWrapper = styled.div`
  border-radius: 20px;
  display: inline-flex;
  margin: ${themeSpace(3)};
`;

export const StyledArrowSvg = styled.svg<{ isOpen?: boolean }>`
  top: ${themeSpace(2)};
  right: ${themeSpace(-2)};
  position: relative;
  ${({ isOpen }) =>
    isOpen
      ? {
          transform: 'rotate(180deg)',
        }
      : null}
`;

export const StyledDropdown = styled(ButtonNoneStyled)<{ isOpen?: boolean }>`
  cursor: pointer;
  padding: 0px ${themeSpace(4)} ${themeSpace(1)};
  text-align: center;
  border: 1px solid rgba(220, 212, 201, 1);
  border-radius: 20px;
  transition-property: color, background-color, box-shadow, border-color;
  transition-duration: 500ms;
  transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  ${({ isOpen }) => (isOpen ? { boxShadow: '0 0 0 2px #2c2925' } : null)}

  &:hover {
    ${({ isOpen }) => (isOpen ? null : { borderColor: '#2c2925' })}
  }
`;

export const SelecteStyledText = styled(Text)`
  top: 0px;
  position: relative;
  display: inline-block;
`;

export const DropdownContainer = styled.ul<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  z-index: 5;
  position: absolute;
  width: 231px;
  padding: ${themeSpace(4)} ${themeSpace(6)};
  margin-top: ${themeSpace(8)};
  background: white;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.03), 0px 10px 60px -20px rgba(44, 41, 37, 0.03), 0px 9px 36px -30px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
`;

export const DropdownContainerItem = styled.li`
  padding-left: 0;
  position: relative;
  height: 26px;
  padding: 0px;
  margin: ${themeSpace(4)} 0px;
`;

export const StyledLabel = styled.label`
  display: block;
  position: relative;
  padding-left: ${themeSpace(7)};
  margin-bottom: ${themeSpace(4)};
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  :hover input ~ .checkmark {
    background: #faf7ff;
    border: 1px solid #bbb1a3;
    box-sizing: border-box;
    border-radius: 2px;
  }

  input:checked ~ .checkmark {
    background: #faf7ff;
  }

  input:checked ~ .checkmark:after {
    display: block;
  }
`;

export const StyledSpan = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  height: 25px;
  width: 25px;
  border: 1px solid #bbb1a3;
  box-sizing: border-box;
  border-radius: 2px;

  :after {
    content: '';
    position: absolute;
    display: none;

    left: ${themeSpace(3)};
    top: ${themeSpace(1)};
    width: 8px;
    height: 12px;
    border: solid #502080;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

export const StyledText = styled(Text)`
  font-size: 15px;
  line-height: 17px;
  padding: ${themeSpace(1)};
  width: 100%;
`;

export const StyledPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  position: relative;
  width: 19px;
  top: 0px;
  right: 30px;
`;

export const StyledFilterCircle = styled(Text)`
  background: #333333;
  color: white;
  font-size: 15px;
  line-height: 19px;
  font-weight: 600;
  border-radius: 16px;
  height: 22px;
  width: 22px;
  display: inline-block;
  padding: 2px;
  margin-left: ${themeSpace(4)};
  &:hover {
    color: white;
  }
`;
